import Work1 from "../../assets/work-1.svg"
import Work2 from "../../assets/work-2.svg"
import Work3 from "../../assets/work-3.svg"
import Work4 from "../../assets/work-4.svg"
import Work5 from "../../assets/work-5.svg"
import Work6 from "../../assets/work-6.svg"


const Menu = [
    {
      id: 1,
      image: Work1,
      title: "Project Management Illustration",
      category: "React",
    },
    {
      id: 2,
      image: Work2,
      title: "Guest App Walkthrough Screens",
      category: "React",
    },
    {
      id: 3,
      image: Work3,
      title: "Delivery App Wireframe",
      category: "React",
    },
    ,
    {
      id: 4,
      image: Work4,
      title: "Onboarding Motivation",
      category: "React",
    },
    ,
    {
      id: 5,
      image: Work5,
      title: "iMac Mockup Design",
      category: "React",
    },
    ,
    {
      id: 6,
      image: Work6,
      title: "Game Store App Concept",
      category: "React",
    }
  ];




export default Menu